import { createAsyncThunk } from "@reduxjs/toolkit";
import statisticApi from "api/statisticApi";
import { formatQueryParams } from "helpers/format";

export const dailyStatistics = createAsyncThunk("Daily Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.dailyStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const hourlyStatistics = createAsyncThunk("Hourly Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.hourlyStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const survivalStatistics = createAsyncThunk("Survival Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.survivalStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const keywordRealTimeStatistics = createAsyncThunk("Keyword Real Time Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.keywordRealTimeStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const keywordPublishedStatistics = createAsyncThunk("Keyword Published Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.keywordPublishedStatistics(formatQueryParams(params, '_z_'))
    return response;
  } catch (error) {
    return error;
  }
});

export const mediaStatistics = createAsyncThunk("Media Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.mediaStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const downloadExcelMediaStatistics = async (params: any = {}) => {
  try {
    const response = await statisticApi.downloadExcelMediaStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const categoryStatistics = createAsyncThunk("Category Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.categoryStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const downloadExcelCategoryStatistics = async (params: any = {}) => {
  try {
    const response = await statisticApi.downloadExcelCategoryStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


export const approvedArticleStatistics = createAsyncThunk("Approved Article Statistics", async (params: any = {}) => {
  try {
    const response = await statisticApi.approvedArticleStatistics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});
